import type { TagFragment } from "@src/__generated__/graphql";
import type { IOption } from "@src/components/ui-kit";

export function toTagOptions(tags: TagFragment[]): IOption[] {
  return tags.map((tag) => ({
    value: tag.id,
    label: tag.title,
  }));
}
